export function checkMobile() {
  return navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
}

/**
 * 通过script在预渲染的时候保存数据，组件加载的时候第一时间读取，避免闪屏情况
 * @param {string} type 保存的key名称
 * @param {any}} data 传入的数据
 */
export function storeDataPrerender(type, data) {
  let typeDom = document.querySelector(`script#${type}`);
  if (!typeDom) {
    const script = document.createElement('script');
    script.id = `${type}`;
    script.innerHTML = `window.__${type}__ = ${JSON.stringify(data)};`;
    document.head.appendChild(script);
  } else {
    typeDom.innerHTML = `window.__${type}__ = ${JSON.stringify(data)};`;
  }
}

export function locationSearchParse() {
  let search = location.search.slice(1) || '';
  if (!search) return {};
  const parseData = {};
  search.split('&').map(item => {
    const [key, ...value] = item.split('=');
    if (key !== undefined && value !== undefined) {
      parseData[key] = value.join('=');
    }
  });
  return parseData;
}
